import { RouteConfig } from 'vue-router'

import { DesignerRoutes } from './modules/designer'

const { AppRoutes } = require('@appRouter')

/**
 * asyncRoutes
 *
 * Rute ini akan dibuat secara dinamis tergantung role pengguna.
 *
 * Rute yang tidak memiliki role berarti dapat diakses oleh semua pengguna.
 */
export const asyncRoutes: Array<RouteConfig> = [
  // ...CEMSRoutes,
  // ...EMONRoutes,
  ...AppRoutes,
  ...DesignerRoutes,

  {
    path: '*',
    name: 'ErrotNotFound',
    component: () => import('@/design/Error/error-404.vue'),
    // redirect: '/404',
    // component: { template: '<div></div>' },
  },
]
